<template>
  <div :class="['active-filters', {disabled}]">
    <div class="active-filters__wrapper">
      <div
        v-for="(filter, index) in activeFilters"
        class="active-filters__item"
        @click="removeFilter(index)"
      >
        {{ renderItemText(filter) }} <i class="fa fa-times active-filters__item-icon" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { isObject, capitalize } from 'lodash'

  export default {
    name: "ActiveFilters",
    props: {
      value: [String, Array],
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        activeFilters: []
      }
    },
    mounted() {
      this.updateActiveFilters(this.value)
    },
    watch: {
      value(nextValue) {
        this.updateActiveFilters(nextValue)
      }
    },
    methods: {
      removeFilter(index){
        if (this.disabled){
          return;
        }

        this.activeFilters.splice(index, 1)
        this.emitUpdateActiveFilters()
      },
      renderItemText(item){
        if (isObject(item)){
          const string = Object.entries(item)[0];
          string[0] = this.runKeyNameFilters(capitalize(string[0]))
          return string.join(": ")
        }
        return item
      },
      emitUpdateActiveFilters() {
        this.$emit('input', this.activeFilters)
      },
      updateActiveFilters(filters) {
        this.activeFilters = filters;
      },
      runKeyNameFilters(string){
        if (string === 'Case'){
          return 'Case Manager'
        }
        return string
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ActiveFilters.vue?fc0a4fe2